
import { onBeforeMount, ref, computed, watch } from 'vue';
// eslint-disable-next-line
//@ts-ignore
import VueLoading from '@/components/general/Loading';
import SingleThought from '@/components/news/SingleThought.vue';
import ThoughtInfiniteList from '@/components/news/ThoughtInfiniteList.vue';
import { domainStore } from '@/store/domain-store';
import { projectStore } from '@/store/project-store';
import thoughtRepository from '@/api/thoughtRepository';
import { useRoute } from 'vue-router';
import { IThought } from '@/models/thought.model';
import useHashParams from '@/composables/general/useHashParams';
import Message from 'primevue/message';
import { IGenericFilter } from '@/models/filter.model';

export default {
  name: 'NewsProject',
  components: { SingleThought, ThoughtInfiniteList, VueLoading, Message },
  props: {
    domainid: {
      type: Number,
      required: true,
    },
    projectid: {
      type: Number,
      required: true,
    },
    thoughtListHeight: {
      type: Number,
      default: 250,
    },
  },

  setup(props: any) {
    const route = useRoute();
    const { deleteHashParam } = useHashParams(route);

    //REF
    const projectEl = ref<HTMLElement>();
    const thought = ref<IThought | null>();
    const isLoading = ref<boolean>(true);
    const errorMsg = ref<IGenericFilter>({
      severity: 'info',
      content: '',
    });

    //COMPUTED
    const currentComponent = computed(() => {
      if ((!thought.value && !isLoading.value) || errorMsg.value.content !== '') {
        return {
          name: 'ThoughtInfiniteList',
          props: {
            thoughtListHeight: props.thoughtListHeight,
            projectid: props.projectid,
          },
        };
      } else if (isLoading.value) {
        return {
          name: 'VueLoading',
          props: { loadingMessage: 'News wird geladen...' },
        };
      } else {
        return {
          name: 'SingleThought',
          props: {
            thought: thought.value,
            thoughtListHeight: props.thoughtListHeight,
          },
        };
      }
    });

    //METHODS
    function onScrollIntoView() {
      projectEl.value?.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    }
    function getThought(thoughtid: number) {
      isLoading.value = true;
      errorMsg.value.content = '';
      thoughtRepository
        .get({ thoughtid: thoughtid })
        .then((result: any) => {
          if (result.data.length > 0) {
            thought.value = result.data[0];
          } else {
            errorMsg.value.severity = 'info';
            errorMsg.value.content = 'Artikel konnte nicht gefunden werden';
          }
        })
        .catch((error: any) => {
          console.log(error);
          errorMsg.value.severity = 'error';
          errorMsg.value.content = 'Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut';
        })
        .finally(() => {
          isLoading.value = false;
        });
    }

    //LIFEHOOKS
    onBeforeMount(() => {
      domainStore.setDomainId(props.domainid);
      projectStore.setProjectId(props.projectid, false);
    });

    watch(
      () => route.query,
      () => {
        if (route.query.thought_id) {
          if (!thought.value || thought.value.id !== Number(route.query.thought_id)) {
            getThought(Number(route.query.thought_id));
          }
        } else {
          thought.value = null;
          isLoading.value = false;
        }
      }
    );
    return {
      // REFS
      thought,
      projectEl,
      // COMPUTED
      currentComponent,
      isLoading,
      errorMsg,
      //METHODS
      onScrollIntoView,
    };
  },
};
